import React, {useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { Label, Row, Col, Card, CardBody, CardHeader, CardFooter } from 'reactstrap';
import FieldButton from 'components/Controls/FieldButton/FieldButton';

import './EnterTicketEmail.scss'
import sapLogo from 'assets/img/SAPLogo.svg'

const EnterTicketEmail = () => {
  const {t, i18n} = useTranslation(['it', 'common']);

  return (
    <>
      <Row>
        <Col>
          <div className='mb-4'>
            <h2 style={{color: 'black'}}>{t("it:NeedHelpFrom")}</h2>
          </div>
          <div className='ticket-selection-sap mb-4'>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} className='p-d-flex align-items-start mb-4'>
                <img src={sapLogo} alt='SAP Logo' style={{height: '2.5rem'}} className='mr-2' />
                <div className='ticket-selection-title mb-2'>{t("it:SAPOperationSupport")}</div>
              </Col>
            </Row>
            <Row className='p-d-flex align-items-start'>
              <Col xs={12} sm={4} md={4} lg={4}>
                <div 
                  className='ticket-selection'
                  onClick={() => window.open('https://deacero.atlassian.net/servicedesk/customer/portal/20/group/263/create/877', '_blank').focus()}
                >
                  <div className='ticket-selection-title mb-2'>{t("it:ReportProblem")}</div>
                  <div>{t("it:ReportProblemDesc")}</div>
                </div>
              </Col>
              <Col xs={12} sm={4} md={4} lg={4}>
                <div 
                  className='ticket-selection'
                  onClick={() => window.open('https://deacero.atlassian.net/servicedesk/customer/portal/20/group/263/create/878', '_blank').focus()}
                >
                  <div className='ticket-selection-title mb-2'>{t("it:ServiceRequest")}</div>
                  <div>{t("it:ServiceRequestDesc")}</div>
                </div>
              </Col>
              <Col xs={12} sm={4} md={4} lg={4}>
                <div 
                  className='ticket-selection'
                  onClick={() => window.open('https://deacero.atlassian.net/servicedesk/customer/user/requests?pIds=20&pIds=20&pIds=20&page=1&reporter=all&rtIds=877&rtIds=878&rtIds=879&statuses=open', '_blank').focus()}
                >
                  <div className='ticket-selection-title mb-2'>{t("it:MyTickets")}</div>
                  <div>{t("it:MyTicketsDesc")}</div>
                  <br />
                </div>
              </Col>
            </Row>
          </div>
          <div
            className='ticket-selection mb-4'
            onClick={() => window.location.href = 'mailto:softwaresupport@mcswusa.com?'}
          >
            <div className='ticket-selection-title mb-2'>{t("it:SoftwareSupport")}</div>
            <div>{t("it:SoftwareSupportDesc")}</div>
          </div>
          <div
            className='ticket-selection'
            onClick={() => window.location.href = 'mailto:itsupport@mcswusa.com?'}
          >
            <div className='ticket-selection-title mb-2'>{t("it:ITHelpDesk")}</div>
            <div>{t("it:ITHelpDeskDesc")}</div>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default EnterTicketEmail;